const es = {
    'proposalProject.table.filter_by_title': 'Filtrar por título',
    'proposalProject.table.filter_by_id': 'Filtrar por ID',
    'proposalProject.table.filter_by_status': 'Filtrar por estado',
    'proposalProject.table.filter_by_description': 'Filtrar por descripción',
    'proposalProject.table.button.requestForProjects': 'Crear solicitud de proyectos',
    'proposalProject.table.button.downloadGuide': 'Descargar guía',

    'proposalProject.table.id': 'Id',
    'proposalProject.table.owner': 'Owner',
    'proposalProject.table.title': 'Título',
    'proposalProject.table.description': 'Descripción',
    'proposalProject.table.jira': 'Jira Epic',
    'proposalProject.table.status': 'Estado',
    'proposalProject.table.actions': 'Acciones',


    'proposalProject.table.modal.delete.phrase': '¿Estás seguro de que quieres eliminar?',
    'proposalProject.table.modal.delete.button.cancel': 'Cancelar',
    'proposalProject.table.modal.delete.button.delete': 'Eliminar',
    'proposalProject.table.modal.delete.title': 'Eliminar',
    'proposalProject.table.modal.restore.title': 'Restaurar',
    'proposalProject.table.modal.restore.done': 'Realizado con éxito',

    'proposalProject.table.modal.close': 'Cerrar',

    'proposalProject.messages.success': 'Éxito',

    'proposalProject.table.modal.restore.button.cancel': 'Cancelar',
    'proposalProject.table.modal.restore.button.restore': 'Restaurar',
    'proposalProject.table.modal.restore.phrase': '¿Estás seguro de que quieres restaurar?',

    'proposalProject.table.filter_by_deleted_not_deleted': 'No eliminado',
    'proposalProject.table.filter_by_deleted_deleted': 'Eliminado',
    'proposalProject.table.filter_by_deleted_all': 'Todo',

    'proposalProject.status.step1': 'Usuario - Paso 1',
    'proposalProject.status.step2': 'Usuario - Paso 2',
    'proposalProject.status.step3': 'IT - Paso 3',
    'proposalProject.status.step4': 'IT - Paso 4',
    'proposalProject.status.standby': 'En espera',
    'proposalProject.status.accepted': 'Aceptado',
    'proposalProject.status.refused': 'Rechazado',
    'proposalProject.status.finished': 'Finalizado',

    // excels
    'proposalProject.excel.titulo_proyecto': 'Nombre del proyecto',
    'proposalProject.excel.id_proyecto': 'Código o ID del proyecto:',
    'proposalProject.excel.fecha_inicio_prevista': 'Fecha de inicio prevista',
    'proposalProject.excel.fecha_finalizacion_prevista': 'Fecha de finalización prevista',
    'proposalProject.excel.resp_proyecto': 'Responsable del proyecto',
    'proposalProject.excel.proyecto_pertenencia': 'Proyecto global al que pertenece',    
    'proposalProject.excel.tipo_iniciativa': 'Tipo de iniciativa',
    'proposalProject.excel.texto_otro_iniciativa': 'Texto de Otro en RESUMEN DEL PROYECTO - TIPO DE INICIATIVA',
    'proposalProject.excel.descripcion_proyecto': 'Descripción y objetivos del proyecto',
    'proposalProject.excel.que_incluye': 'Que incluye el proyecto',
    'proposalProject.excel.que_excluye': 'Que excluye el proyecto',  
    'proposalProject.excel.departamentos_proyecto': 'Departamentos afectados',
    'proposalProject.excel.usuarios_impacto': 'Usuarios impactados',
    'proposalProject.excel.nivel_impacto': 'Nivel de impacto',
    'proposalProject.excel.tipo_impacto': 'Tipo de impacto',
    'proposalProject.excel.texto_otro_impacto': 'Texto de Otro en ALCANCE Y ÁREAS IMPLICADAS DEL PROYECTO - Tipo de impacto',
    'proposalProject.excel.objetivos_proyecto': 'Objetivos estratégicos que apoya',
    'proposalProject.excel.objetivosOperacionales_proyecto': 'Objetivos operacionales relacionados',
    'proposalProject.excel.exp_si_esfuerzo': 'EXPECTATIVAS SI - ESFUERZO',
    'proposalProject.excel.exp_si_grado_cump': 'EXPECTATIVAS SI - GRADO CUMPLIMIENTO',
    'proposalProject.excel.exp_si_impacto': 'EXPECTATIVAS SI - IMPACTO',
    'proposalProject.excel.exp_negocio_esfuerzo': 'EXPECTATIVAS NEGOCIO - ESFUERZO',
    'proposalProject.excel.exp_negocio_grado_cump': 'EXPECTATIVAS NEGOCIO - GRADO DE CUMPLIMIENTO',
    'proposalProject.excel.exp_negocio_impacto': 'EXPECTATIVAS NEGOCIO - IMPACTO',
    'proposalProject.excel.exp_negocio_nvl_satis': 'EXPECTATIVAS NEGOCIO - NIVEL DE SATISFACCIÓN',
    'proposalProject.excel.val_neg_dpt': 'VALIDACIÓN Fila Negocio - Departamento',
    'proposalProject.excel.val_neg_cargo': 'VALIDACIÓN Fila Negocio - Cargo',
    'proposalProject.excel.val_neg_nombre': 'VALIDACIÓN Fila Negocio - Nombre',
    'proposalProject.excel.val_neg_fecha': 'VALIDACIÓN Fila Negocio - Fecha',
    'proposalProject.excel.val_neg_comentarios': 'VALIDACIÓN Fila Negocio - Comentarios',
    'proposalProject.excel.val_si_cargo': 'VALIDACIÓN Fila SI - Cargo',
    'proposalProject.excel.val_si_nombre': 'VALIDACIÓN Fila SI - Nombre',
    'proposalProject.excel.val_si_fecha': 'VALIDACIÓN Fila SI - Fecha',
    'proposalProject.excel.val_si_comentarios': 'VALIDACIÓN Fila SI - Comentarios',
};
export default es;